import { Box, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { FunctionComponent } from 'react';
import { gameStyles } from '../../config/GameTheme';
import { Sound, useMusic } from '../../Sound';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { AsyncAnimationProps, waitForAnimation } from '../../util/Animation';
import { FullScreenMessage } from './FullScreenMessage';

type Props = AsyncAnimationProps & {
	roundNumber: number;
};

export const RoundTransition: FunctionComponent<Props> = (props) => {
	const round = useGameplaySelector(gamePlayStore.selectors.round);
	const theme = useTheme();

	// No music for first round to allow for welcome music
	useMusic(Sound.effects.RoundWin, props.show && (round > 0));

	async function onTransitionComplete() {
		await waitForAnimation({ seconds: 1 });
		props.onComplete?.();
	};

	return <FullScreenMessage
		key={`question-${props.roundNumber}`}
		show={props.show}
		animationType="fade"
		duration={dayjs.duration(2, 'seconds')}
		onComplete={onTransitionComplete}
		sx={gameStyles.boardBackground}
	>
		<Box sx={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%',
			width: '100%',
			gap: 4,
		}}>
			<Box sx={{
				textAlign: 'center',
				paddingY: 2,
				paddingX: 4,
				bgcolor: theme.palette.game.gold,
				borderRadius: '16px',
				border: `4px solid ${theme.palette.game.white}`,
			}}>
				<Typography variant="h1" sx={{
					fontWeight: 'bold',
					color: theme.palette.game.textDark,
				}}>
					Round {props.roundNumber + 1}
				</Typography>
			</Box>
		</Box>
	</FullScreenMessage>;
};
